module.exports = __webpack_public_path__ + "img/search-logo.4f135385.png";